import { useCallback } from 'react'
import { useI18nQuery } from 'api/i18n'
import { useNotificationCount } from 'api/inbox'
import { useGlobalStore } from 'global-state'
import { CLIENT_MENU_OPTIONS } from 'constants/misc'

export type DictArgs = { [a: string]: string }

function translate(key: string, dict: DictArgs, args?: DictArgs): string {
  if (localStorage.getItem('lotto-show-i18n-keys')) {
    return key
  }

  const translation = dict[key]

  if (args && translation) {
    return Object.entries(args).reduce((acc, [key, val]) => {
      return acc.replaceAll(`{${key}}`, val)
    }, translation)
  }

  return translation || key
}

export function useI18n() {
  const selectedLanguage = useGlobalStore((s) => s.selectedLanguage)
  const query = useI18nQuery(selectedLanguage || '')

  return useCallback(
    (key: string, args?: DictArgs) => {
      return query.data ? translate(key, query.data, args) : key
    },
    [query.data, selectedLanguage] // eslint-disable-line
  )
}

export const useClientMenuTranslationArgs = () => {
  const { unreadCount } = useNotificationCount()
  return (option: (typeof CLIENT_MENU_OPTIONS)[number]) => {
    if (option === 'inbox') return { unreadCount: `${unreadCount}` }
    return undefined
  }
}
